import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone (optional)", -1)
const _hoisted_4 = { class: "form-check" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ml-2",
  for: "smsCheckBox"
}, [
  /*#__PURE__*/_createTextVNode(" Receive SMS service notifications "),
  /*#__PURE__*/_createElementVNode("p", { class: "sms-disclaimer" }, [
    /*#__PURE__*/_createTextVNode(" Your mobile number must be able to receive text messages. Message and data rates may apply. Message frequency varies based on user interaction. Text "),
    /*#__PURE__*/_createElementVNode("b", null, "STOP"),
    /*#__PURE__*/_createTextVNode(" to +1 (617) 390-7187 to cancel at any time. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://solutions.openbay.com/openbay-terms-of-service/#Openbay%20Terms%20of%20Service%20and%20Conditions",
      target: "_blank"
    }, "Terms of service"),
    /*#__PURE__*/_createTextVNode(". "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://solutions.openbay.com/openbay-terms-of-service/#Privacy%20Policy",
      target: "_blank"
    }, "Privacy policy"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_7 = { class: "sign-up-form-footer" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_email_input = _resolveComponent("email-input")!
  const _component_name_input = _resolveComponent("name-input")!
  const _component_password_input = _resolveComponent("password-input")!

  return (_openBlock(), _createElementBlock("form", {
    ref: "contactForm",
    class: "sign-up-form form-float",
    onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signUpUser && _ctx.signUpUser(...args)), ["prevent"]))
  }, [
    (_ctx.isJoinPlus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_email_input, {
            modelValue: _ctx.newUser.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUser.email) = $event)),
            class: "mb-1",
            "initial-email": _ctx.initialEmail,
            disabled: true
          }, null, 8, ["modelValue", "initial-email"]),
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('change-email')), ["prevent"]))
          }, "Change email address")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_name_input, {
      modelValue: _ctx.newUser.firstName,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.firstName) = $event)),
      class: "mb-4",
      placeholder: "First Name",
      autocomplete: "given-name",
      "error-string": "First name is required.",
      onNameUpdate: _ctx.updateFirstName,
      onNameValidUpdate: _ctx.updateFirstNameValidity
    }, null, 8, ["modelValue", "onNameUpdate", "onNameValidUpdate"]),
    _createVNode(_component_name_input, {
      modelValue: _ctx.newUser.lastName,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newUser.lastName) = $event)),
      class: "mb-4",
      placeholder: "Last Name",
      autocomplete: "family-name",
      "error-string": "Last name is required.",
      onNameUpdate: _ctx.updateLastName,
      onNameValidUpdate: _ctx.updateLastNameValidity
    }, null, 8, ["modelValue", "onNameUpdate", "onNameValidUpdate"]),
    (!_ctx.isJoinPlus)
      ? (_openBlock(), _createBlock(_component_email_input, {
          key: 1,
          modelValue: _ctx.newUser.email,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.email) = $event)),
          class: "mb-4",
          "initial-email": _ctx.initialEmail,
          onEmailUpdate: _ctx.updateEmail,
          onEmailValidUpdate: _ctx.updateEmailValidity
        }, null, 8, ["modelValue", "initial-email", "onEmailUpdate", "onEmailValidUpdate"]))
      : _createCommentVNode("", true),
    _createVNode(_component_password_input, {
      modelValue: _ctx.newUser.password,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newUser.password) = $event)),
      "initial-password": _ctx.newUser.password,
      placeholder: "Password",
      autocomplete: "new-password",
      onPasswordUpdate: _ctx.updatePassword,
      onPasswordValidUpdate: _ctx.updatePasswordValidity
    }, null, 8, ["modelValue", "initial-password", "onPasswordUpdate", "onPasswordValidUpdate"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        id: "phone",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newUser.phoneNumber) = $event)),
        placeholder: "(__) ___-____",
        type: "tel",
        class: "form-control",
        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setSMS && _ctx.setSMS(...args)))
      }, null, 544), [
        [_vModelText, _ctx.newUser.phoneNumber]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        id: "smsCheckBox",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUser.smsEnabled) = $event)),
        class: "form-check-input",
        type: "checkbox",
        value: "",
        disabled: _ctx.phoneNumberExists == false
      }, null, 8, _hoisted_5), [
        [_vModelCheckbox, _ctx.newUser.smsEnabled]
      ]),
      _hoisted_6
    ]),
    _createElementVNode("footer", _hoisted_7, [
      _createElementVNode("button", {
        type: "submit",
        class: _normalizeClass([{ loading: _ctx.loading }, "btn btn-primary mb-3"]),
        disabled: !_ctx.allFieldsValid || _ctx.loading
      }, _toDisplayString(_ctx.submitText), 11, _hoisted_8)
    ])
  ], 544))
}